module.exports = __webpack_public_path__ + "img/galery-kx5200-1-zoom.ed8f1a32.png";